export default {
    message: {
        hello: 'Bonjour monde'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/fr.js